export default __webpack_public_path__ + "3bcb65afe3a65ad3663b33e372777797.svg";